import type { EditBonusRequestProps } from '@services/api/bonus/types'
import type { EditBonusModalFormProps } from '../components/EditBonusModal/form/types'

export const parseEditBonusPayload = (formData: EditBonusModalFormProps) => {
  const payload: EditBonusRequestProps = {
    routeParams: {
      filiCode: formData.filiCode || '',
      competenceDate: formData.startPeriod || ''
    },
    bodyParams: {
      branchCode: formData.branchCode || '',
      bonusReferenceDate: formData.bonusReferenceDate || '',
      previewNumber: formData.previewNumber || 0,
      previewBonusAmount: formData.bonificationTotal ? Number(formData.bonificationTotal) : 0,
      previewConsumptionAmount: formData.previewConsumptionAmount || 0,
      deviationPercentage: formData.deviation ? Number(formData.deviation) : 0,
      previewPercentage: formData.previewPercentage || 0,
      adjustmentPercentage: formData.adjustment ? Number(formData.adjustment) : '',
      observation: formData.observations ? String(formData.observations) : '',
      updatedAt: formData.updatedAt || '',
      previewStatus: formData.previewStatus || '',
      isCurrentPreview: !!formData.isCurrentPreview
    }
  }

  return payload
}
